import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  body: {
    display: "flex",
    flexDirection:"column",
    marginTop: "48px",
    paddingLeft: "55px",
    paddingRight: "55px",
  },
  titleTextSection: {
      display:"flex",
      justifyContent:"center",
  },
  skipTextSection: {
      display:"flex",
      justifyContent:"flex-end",
      height:"fit-content",
      marginBottom:"70px",
  },
  illustrationSection: {
      marginBottom:"150px",
      width:"100%",
      justifyContent:"center",
      display:"flex",
  },
  buttonSection: {
      paddingRight:"50px",
      paddingLeft:"50px",
      paddingBottom:"30px",
      height:"63px",
  },
  groupButtonSection: {
    paddingRight:"50px",
    paddingLeft:"50px",
    display:"flex",
    flexDirection:"column",
    gap:"15px",
    height:"150px",
},
  titleText: {
      fontSize:"22px !important",
      fontWeight:"bold !important",
      color:"#ffffff",
      paddingBottom:"43px",
  },
  detailText: {
      fontSize:"15px !important",
      color:"#c1c1c1",
      paddingBottom:"64px",
      textAlign:"center",
  },
}));

export default useStyles;
